import { render, staticRenderFns } from "./Antispamtype.vue?vue&type=template&id=6d1dfa8a&"
import script from "./Antispamtype.vue?vue&type=script&lang=js&"
export * from "./Antispamtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports